import { CButton, CCol, CFormInput, CModal, CModalBody, CModalDialog, CModalFooter, CModalHeader, CModalTitle } from "@coreui/react";
import { useRef } from "react";

export default function MfaModal({ visible, mfaError, handleMfaLogin, handleClose }) {
    const mfaToken = useRef();

    return (
        <CModal alignment="center" backdrop="static" visible={visible} onClose={handleClose} >
            <CModalHeader>
                <CModalTitle>Multi Factor Authentication <b style={{ color: 'green', fontWeight: '600', fontSize: '20px' }}>*NEW*</b> </CModalTitle>
            </CModalHeader>
            <CModalBody>
                <CCol>
                    <CModalDialog>
                        <p>Titanium has updated the Driver Portal to use Multi Factor Authentication(MFA). Please contact the Safety Team if your phone number has changed and needs to be updated.</p>
                        <p>A text message has been sent to your phone with a <b>verification code</b>. Please enter the verification code below to sign in. </p>
                    </CModalDialog>
                    <CFormInput className='fs-4' placeholder='Verification Code' ref={mfaToken} />
                    {mfaError && <p style={{ color: 'red', fontWeight: '600', fontSize: '20px' }}>{mfaError}</p>}
                </CCol>
            </CModalBody>
            <CModalFooter>
                <CButton color="primary" onClick={() => { handleMfaLogin(mfaToken.current.value) }}>Verify</CButton>
            </CModalFooter>
        </CModal>
    )
}